<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [canGoBack]="true"
      [title]="'Book Job'" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  @if (loaded) {
    <tidy-wrapper>
      <tidy-row [align]="'center'">
        <tidy-text
          [body]="'What would you like to book with'" /><span>&nbsp;</span>
          <tidy-text
            [body]="proName + '?'" />
        </tidy-row>
        <tidy-button
          [text]="'Reschedule Current Plan'"
          [action]="boundGoToReschedulePlan"
          class="primary" />
        <tidy-button
          [text]="'Add One Time Job'"
          [action]="boundGoToAddOneTimeJob"
          class="primary" />
      </tidy-wrapper>
    }
  </ng-template>

  @if (!isRightSideContent) {
    <app-scroll-wrapper [templateContent]="content" />
  }

  @if (isRightSideContent) {
    <ion-content class="ion-content-right-column">
      <ng-container *ngTemplateOutlet="content" />
    </ion-content>
  }
